import { type JSX } from 'react';
import { CalendarClock, Car } from 'lucide-react';

export type TunnelMode = 'booking' | 'ride';

export interface TunnelModeSwitchLabels {
  booking: string;
  bookingSubtitle?: string;
  ride: string;
  rideSubtitle?: string;
}

export interface TunnelModeSwitchProps {
  mode: TunnelMode;
  onChange: (mode: TunnelMode) => void;
  labels: TunnelModeSwitchLabels;
}

/**
 * Sélecteur « Prestations | Trajet » injecté dans le `headerAccessory` des tunnels booking/ride
 * (miroir du modeSwitcher de /book côté frontend-web). Segmented compact icône + libellé, hérite
 * des tokens `--bt-*` du `.bt-root` parent — utilisé par le booking-widget des sites publics.
 */
export function TunnelModeSwitch({ mode, onChange, labels }: TunnelModeSwitchProps): JSX.Element {
  const options: { mode: TunnelMode; icon: typeof CalendarClock; title: string; subtitle?: string }[] = [
    { mode: 'booking', icon: CalendarClock, title: labels.booking, subtitle: labels.bookingSubtitle },
    { mode: 'ride', icon: Car, title: labels.ride, subtitle: labels.rideSubtitle },
  ];
  return (
    <div className="bt-modes">
      {options.map(({ mode: m, icon: Icon, title, subtitle }): JSX.Element => {
        const active = mode === m;
        return (
          <button
            key={m}
            type="button"
            aria-pressed={active}
            title={subtitle}
            onClick={(): void => onChange(m)}
            className={`bt-mode ${active ? 'bt-mode--active' : ''}`}
          >
            <Icon size={15} strokeWidth={2} aria-hidden="true" />
            {title}
          </button>
        );
      })}
    </div>
  );
}
